import { Spinner, SizableText, YStack } from 'tamagui';
import type { SpinnerProps } from 'tamagui';
import React from 'react';

export interface LoadingViewProps {
  /** Optional label to display below the spinner. */
  message?: string;
  /** Spinner size inherits from Tamagui Spinner props. */
  spinnerSize?: SpinnerProps['size'];
}

export const LoadingView = ({
  spinnerSize = 'large',
  message,
}: LoadingViewProps): React.ReactElement => (
  <YStack
    flex={1}
    alignItems="center"
    justifyContent="center"
    gap="$2"
    padding="$true"
  >
    <Spinner size={spinnerSize} color="$secondary" />
    {message && (
      <SizableText size="$2" color="$secondary" textAlign="center">
        {message}
      </SizableText>
    )}
  </YStack>
);
